export default __webpack_public_path__ + "static/media/account.06b64882.svg";